"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import type { UseFormProps, UseFormReturn } from "react-hook-form";
import { useForm as useReactHookForm } from "react-hook-form";
import type z from "zod";

export function useForm<Schema extends z.ZodObject, Context = unknown>({
  schema,
  ...props
}: Omit<UseFormProps<z.input<Schema>, Context, z.output<Schema>>, "resolver"> & {
  schema: Schema;
}): UseFormReturn<z.input<Schema>, Context, z.output<Schema>> {
  return useReactHookForm<z.input<Schema>, Context, z.output<Schema>>({
    resolver: zodResolver(schema),
    mode: "onBlur",
    ...props,
  });
}
